/* Built In Imports */
import Head from 'next/head';
import { useContext, useState, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import OthersCommonUI from '@components/UI/Others/OthersCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
  getCurrentRegion,
} from 'services/commonService';
import { fetchDetails, getLandingPaths, fetchPBKOnlineContentData } from 'services/othersService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Center Landing Page Data
 */

const PBKOnline = ({ region, language, pageData }) => {
  const pageConfig = pageData?.pageConfig != null ? pageData?.pageConfig[0]?.value : ''; 
  const breadcrumbVisibility = pageData?.pageConfig != null ? pageData?.pageConfig[0]?.value?.breadcrumb !== 'disable' : '';
  const [programData, setProgramData] = useState('');
  const [currentRegion, setCurrentRegion] = useState('');
  
  useEffect(() => {
    localData(region, language);
  }, [region, language]);

  const localData = async (region, language) => {
    const reg = await getCurrentRegion();
    if (reg?.country) {
      setCurrentRegion(reg.country);
    }
    let programData = await fetchPBKOnlineContentData(region, language);
    // let programData = {
    //         "jsonrpc": "2.0",
    //         "id": null,
    //         "result": [
    //             {
    //                 "id": 736,
    //                 "name": "Pancha Bhuta Kriya online with Sadhguru on Mahashivratri - 2024",
    //                 "url_registration": "https://preprod-online.sadhguru.org/event-register?event=pancha-bhuta-kriya-online-with-sadhguru-on-mahashivratri-2024-736&country_code=IN",
    //                 "url_enquiry": null,
    //                 "start_date": "2024-03-08 03:00:00",
    //                 "end_date": "2024-03-08 18:30:00",
    //                 "seats_available": 999999,
    //                 "max_per_booking": 1,
    //                 "tickets": [
    //                     {
    //                         "id": 1634,
    //                         "name": "Registration",
    //                         "seats_available": 99999,
    //                         "start_date": false,
    //                         "end_date": false,
    //                         "price": 2500.0,
    //                         "currency": "INR",
    //                         "person_count": 1,
    //                         "is_expired": false
    //                     }
    //                 ],
    //                 "batches": [],
    //                 "center": "Isha Yoga Center - Coimbatore",
    //                 "venue": {
    //                     "name": "Isha Yoga Center, coimbatore",
    //                     "street": "Velliyangiri Foot hills",
    //                     "street_2": "Ishana Vihar Post",
    //                     "city": "Coimbatore",
    //                     "state": "Tamil Nadu",
    //                     "country": "India",
    //                     "country_code": "IN",
    //                     "zip": "641114"
    //                 },
    //                 "is_free": 0,
    //                 "queried_country_code": "IN",
    //                 "regional_support_email": "pbkwithsadhguru@sadhguru.org",
    //                 "regional_support_phone": false,
    //                 "regional_notes": "Pancha Bhuta Kriya Kit is not included in the program fee. Details of how the kit can be purchased will be shared upon registration.",
    //                 "is_registration_allowed": true
    //             }
    //         ]
    //     };
    setProgramData(programData);
  };
  return (
    <WrapLayout>
      <Head>
        <meta name="robots" content="notranslate" />
      </Head>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
        pageconfig={pageData?.pageConfig}
      />
      {breadcrumbVisibility && <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />}

      <Box as="section" className="page-wrap container-article" p="0">
        <OthersCommonUI
          pageBody={pageData?.body[0]?.value?.length
            ? pageData?.body[0]?.value
            : pageData?.body}
          region={region}
          lang={language}
          pageName={pageConfig?.pageName}
          csrData={programData}
          currentRegion={currentRegion}
        />
      </Box>
      <style jsx global>
          {`
            .slick-dots li p {
              background-color: #D3D3D3;
            }
            .slick-dots li.slick-active p {
              background-color: #808080;
            }
          `}
        </style>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const othersLandingPaths = config.USE_LOCAL_URL
    ? [
        `/in/en/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/in/ta/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/in/te/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/in/kn/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/uk/en/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/us/en/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/ca/en/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/global/en/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/global/fr/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/global/es/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`,
        `/global/ru/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`
    ]
    : await getLandingPaths('lvl0', '/pancha-bhuta-kriya-online-with-sadhguru-mahashivratri');
  return {
    paths: othersLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, others },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language, `pancha-bhuta-kriya-online-with-sadhguru-mahashivratri`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default PBKOnline;